import { map } from 'rxjs/operators';
import { CatalogRecord } from 'shared';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { limit, orderBy, QueryConstraint, startAfter, where } from '@angular/fire/firestore';
import { DbService } from 'src/app/services/db.service';

@Injectable({
  providedIn: 'root'
})
export class CatalogService {
  private _db = inject(DbService);

  constructor() {}

  keywordSearch(keyword: string, limitVal = 3): Observable<CatalogRecord[]> {
    const constraints: QueryConstraint[] = [
      where('inCatalog', '==', true),
      where('searchTerms', 'array-contains', keyword.toLowerCase()),
      limit(limitVal)
    ];
    return this._db.queryCollection$<CatalogRecord>('catalog-records', constraints).pipe(
      map((records) => {
        return records.map((record) => {
          return record;
        });
      })
    );
  }

  getCatalogRecords(
    searchTerm: string = '',
    startAfterVal: any = '',
    limitVal = 20,
    category?: string
  ): Observable<CatalogRecord[]> {
    const constraints: QueryConstraint[] = [orderBy('name', 'asc')];
    if (category) {
      constraints.push(where('category', '==', category?.toLowerCase()));
    }
    if (searchTerm) {
      constraints.push(where('searchTerms', 'array-contains', searchTerm.toLowerCase()));
    }
    constraints.push(where('inCatalog', '==', true));
    if (startAfterVal) {
      constraints.push(startAfter(startAfterVal));
    }
    constraints.push(limit(limitVal));

    return this._db.queryCollection$<CatalogRecord>('catalog-records', constraints).pipe(
      map((record) => {
        return record.map((doc) => {
          return doc;
        });
      })
    );
  }
}
